/**
 * variant-default-b2.js — Foliove custom (Horizon)
 *
 * Sur les fiches produit avec une option taille (A4/A3/B2/B1/B0), force
 * la sélection initiale sur B2. Affichage seul : ne réécrit pas l'ordre
 * des variantes côté serveur, ne modifie pas le SEO / Google Shopping.
 *
 * Comportement :
 *   1. Si ?variant=… déjà dans l'URL → no-op (l'URL gagne).
 *   2. Sinon, cherche un radio dont la valeur contient le marqueur B2
 *      dans l'une des deux conventions du store :
 *         - convention A : « B2 ( 50 x 70 cm) »  → commence par B2
 *         - convention B : « 50x70 cm (B2) »     → B2 après une (
 *      Pattern /(?:^|\()b2\b/i couvre les deux ; \b empêche le match
 *      sur « B20 » hypothétique.
 *   3. Si trouvé, dispo (data-option-available="true") et pas déjà
 *      coché, .click() pour déclencher le change natif Horizon
 *      (recalcule prix / image / CTA).
 *   4. Si pas de B2 → no-op (fallback natif Shopify).
 *   5. Toujours pose data-default-resolved="true" sur le picker pour
 *      démasquer le CSS anti-flash.
 *
 * Timing : on attend explicitement que <variant-picker> ET
 * <product-price> soient `:defined` avant de cliquer. C'était le bug —
 * sans cette attente, le click partait à readyState='interactive'
 * avant que product-price n'ait attaché son listener variant:update.
 * La fetch côté Horizon partait quand même, l'event était dispatché,
 * mais personne ne l'écoutait → le prix visible restait sur la
 * variante server-rendered (A3/B0 selon le produit).
 */
(function () {
  var B2_PATTERN = /(?:^|\()b2\b/i;

  function resolveDefault(picker) {
    try {
      if (new URL(window.location.href).searchParams.has('variant')) return;
      var radios = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var radio = radios[i];
        if (radio.checked) continue;
        if (radio.dataset.optionAvailable !== 'true') continue;
        if (B2_PATTERN.test(radio.value || '')) {
          radio.click();
          return;
        }
      }
    } finally {
      picker.setAttribute('data-default-resolved', 'true');
    }
  }

  function resolveAll() {
    document.querySelectorAll('variant-picker').forEach(resolveDefault);
  }

  function start() {
    // Attend que les composants impliqués dans le flux variant:update
    // soient enregistrés (et donc que leurs connectedCallback aient
    // attaché les listeners). product-price est obligatoire ici — sans
    // son listener, l'event variant:update dispatché par variant-picker
    // après la fetch tombe dans le vide et le prix ne suit pas le click.
    var waiters = [customElements.whenDefined('variant-picker')];
    if (document.querySelector('product-price')) {
      waiters.push(customElements.whenDefined('product-price'));
    }
    Promise.all(waiters).then(function () {
      // rAF défensif : laisse à Horizon un dernier tick pour finir de
      // câbler les listeners sur les instances éventuellement upgradées
      // après nous, avant d'envoyer le click.
      requestAnimationFrame(resolveAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
